import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OnboardingContext } from '../InvoiceOnboarding';
import {
  ACTUAL_FLOW_STEPS, STYLES, SUBMIT_TYPES, TEXTS,
} from '../consts/consts';
import LinedStepper from '../../../../generic-components/LinedStepper';
import Button from '../../../../generic-components/Button';
import MainContent from '../../../../generic-components/Layout/MainContent';
import ColorList from './ColorList';
import Icon from '../../../../generic-components/Icon';
import { backBlackIcon } from '../../../../assets/svg';
import Heading from '../../../../generic-components/Heading';
import { InvoicesContext } from '../../contexts/InvoicesContext';

const StepColor = () => {
  const { t } = useTranslation();
  const invoiceContext = useContext(InvoicesContext);
  const flowContext = useContext(OnboardingContext);
  const {
    onStepSubmit, activeStep, customizationData, isLoadingState,
  } = flowContext;

  const [selectedColors, setSelectedColors] = useState<string[]>([]);
  const handleColorSelection = (colorList: string[]) => {
    setSelectedColors(colorList);
    onStepSubmit({ type: SUBMIT_TYPES.COLOR.PICKED_COLOR, data: colorList[0] });
  };

  const isEditMode = !!invoiceContext.initialObStep;

  const getPreSelectedColor = () => {
    if (!isEditMode && flowContext?.invoiceCustomData?.brandColor) {
      return `#${flowContext?.invoiceCustomData?.brandColor.replaceAll('#', '')}`;
    } if (invoiceContext?.settings?.brandColor) {
      return invoiceContext?.settings?.brandColor;
    }
    return '';
  };

  return customizationData?.brandColors ? (
    <MainContent
      className={STYLES.PAGES.COLOR.MAIN_CONTENT}
    >
      {!isEditMode && (
      <LinedStepper
        currentStep={activeStep}
        mainContainerCSS={STYLES.LINED_STEPPER.MAIN_CONTAINER}
        passStepAnimation={STYLES.LINED_STEPPER.STEP_ANIMATION}
        stepCSS={STYLES.LINED_STEPPER.STEP}
        stepContainerCSS={STYLES.LINED_STEPPER.STEP_CONTAINER}
        stepsAmount={ACTUAL_FLOW_STEPS}
      />
      )}
      <Heading className={STYLES.PAGES.LOGO.TITLE} title={t(TEXTS.STEP_COLOR.TITLE)} />
      <ColorList defaultColorId={getPreSelectedColor()} items={customizationData.brandColors} selectedItems={selectedColors} setSelectedItems={handleColorSelection} />
      <div className={`${STYLES.PAGES.COLOR.FOOTER_ACTIONS_WRAPPER} ${isEditMode ? 'justify-center' : 'justify-between'}`}>
        {!isEditMode && (
        <Button
          onClick={() => onStepSubmit({ type: SUBMIT_TYPES.COLOR.NAVIGATE_BACK, data: '' })}
          childElement={<Icon className={STYLES.PAGES.COLOR.CTA_BACK_ICON} src={backBlackIcon} />}
          title={t(TEXTS.STEP_COLOR.CTA_BACK)}
          className={STYLES.PAGES.COLOR.CTA_BACK}
          id='elCtaBack'
          disable={isLoadingState}
        />
        )}
        <Button
          disable={isLoadingState}
          isLoading={isLoadingState}
          onClick={() => onStepSubmit({ type: '', data: '' })}
          title={invoiceContext.initialObStep ? t('ACTION_TYPE_UPDATE') : t(TEXTS.STEP_COLOR.CTA_NEXT)}
          className={STYLES.PAGES.COLOR.CTA_CONTINUE}
          id='elCtaContinue'
        />
      </div>
    </MainContent>
  ) : <div>Fallback</div>;
};

export default StepColor;
